import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import LandingPage from "@/pages/LandingPage";
import DonationCheckout from "@/pages/DonationCheckout";
import DonationSuccess from "@/pages/DonationSuccess";
import DonationCancel from "@/pages/DonationCancel";
import PrivacyPolicyPage from "@/pages/PrivacyPolicy";
import ConsentBanner from "@/components/consent/ConsentBanner";
import Ga4Tracker from "@/components/analytics/Ga4Tracker";
import BackToTopButton from "@/components/navigation/BackToTopButton";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Ga4Tracker />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/donate/checkout" element={<DonationCheckout />} />
          <Route path="/donate" element={<DonationCheckout />} />
          <Route path="/donation-success" element={<DonationSuccess />} />
          <Route path="/donation-cancel" element={<DonationCancel />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <ConsentBanner />
        <BackToTopButton />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
